class BoxStory {
  constructor() {
    this.items = Array.prototype.slice.call(document.querySelectorAll('[data-box-story-item]'));
    this.activeOverlay = null;

    if (!this.items.length) {
      return;
    }

    this.items.forEach((item) => this.initItem(item));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' || event.code === 'Escape') {
        this.closeActive();
      }
    });
  }

  initItem(item) {
    const openBtn = item.querySelector('[data-box-story-open]');
    const closeBtn = item.querySelector('[data-box-story-close]');
    const overlay = item.querySelector('[data-box-story-overlay]');

    if (!openBtn || !closeBtn || !overlay) {
      return;
    }

    openBtn.addEventListener('click', () => this.open(item, openBtn, overlay));
    closeBtn.addEventListener('click', () => this.close(item, openBtn, overlay));
  }

  open(item, openBtn, overlay) {
    this.closeActive();
    overlay.hidden = false;
    overlay.classList.add('is-open');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('is-box-story-open');
    this.activeOverlay = { item, openBtn, overlay };
  }

  close(item, openBtn, overlay) {
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('is-box-story-open');

    if (this.activeOverlay && this.activeOverlay.overlay === overlay) {
      this.activeOverlay = null;
    }
  }

  closeActive() {
    if (!this.activeOverlay) {
      return;
    }

    const { item, openBtn, overlay } = this.activeOverlay;
    this.close(item, openBtn, overlay);
  }
}

export default BoxStory;
